import initSlickSlider from '../utils/initSlickSlider';
import { COMMON_SLICK_SLIDER_OPTIONS, BREAKPOINT } from '../utils/constants';

const selectors = {
    sliderWrapper: '.js-cases-slider-parent',
    slider: '.js-cases-slider',
    slide: '.js-cases-slide',
    dotsContainer: '.js-slick-slider-navigation-dots',
    prevArrow: '.js-slick-slider-prev-btn',
    nextArrow: '.js-slick-slider-next-btn'
};

const casesSlider = () => {
    const $slider = $(selectors.slider);

    if (!$slider) {
        return;
    }

    const prevArrow = $slider.closest(selectors.sliderWrapper).find(selectors.prevArrow);
    const nextArrow = $slider.closest(selectors.sliderWrapper).find(selectors.nextArrow);
    const dotsContainer = $slider.closest(selectors.sliderWrapper).find(selectors.dotsContainer);

    const options = $.extend({}, COMMON_SLICK_SLIDER_OPTIONS, {
        prevArrow,
        nextArrow,
        appendDots: dotsContainer,
        responsive: [
            {
                breakpoint: 549,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 989,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: BREAKPOINT.OLD_FASHION_DESKTOP - 1,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });

    initSlickSlider($slider, options);
};
export default casesSlider;
